import isNumber from './is-number';

const isNegative = function(num: any): boolean {
  return isNumber(num) && num < 0;
};

export default isNegative;
